import React from 'react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-sky-100 px-6 py-12 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-md p-8 max-w-4xl w-full">
        <h1 className="text-3xl font-bold text-blue-600 mb-6">Terms of Service</h1>

        <p className="text-gray-700 mb-4">
          Welcome to <strong>Audio & Video To Text Convertor  (PScribes)</strong> provided by SA Tech Inc. These Terms of Service ("Terms") govern your access to and use of our website and services.
        </p>

        <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">1. Acceptance of Terms</h2>
        <p className="text-gray-700 mb-4">
          By using our services, you agree to be bound by these Terms. If you do not agree to any part of the terms, you may not use our platform.
        </p>

        <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">2. Use of the Service</h2>
        <p className="text-gray-700 mb-4">
          You may use our service only for lawful purposes. You must not upload content that infringes on others' rights or violates any laws.
        </p>

        <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">3. User Content</h2>
        <p className="text-gray-700 mb-4">
          You retain ownership of the audio or video content you upload. We do not store your files permanently. Your files are processed temporarily for transcription purposes and then deleted.
        </p>

        <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">4. No Guarantees</h2>
        <p className="text-gray-700 mb-4">
          While we strive for accurate transcriptions, we do not guarantee 100% accuracy. The output may vary depending on audio quality, language, and background noise.
        </p>

        <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">5. Service Availability</h2>
        <p className="text-gray-700 mb-4">
          We may modify, suspend, or discontinue any part of the service at any time without notice or liability.
        </p>
		
		<h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">6. Limitation of Liability</h2>
        <p className="text-gray-700 mb-4">
          To the fullest extent permitted by law, SA Tech Inc shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to loss of profits, data, or other intangible losses resulting from:
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-4">
          <li>Your use or inability to use the service</li>
          <li>Any errors or inaccuracies in the transcription</li>
          <li>Unauthorized access to or alteration of your data</li>
          <li>Any other matter related to the use of our service</li>
        </ul>
        <p className="text-gray-700 mb-4">
          You agree that your use of the service is at your own risk.
        </p>

        <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">7. Changes to Terms</h2>
        <p className="text-gray-700 mb-4">
          We may update these Terms occasionally. Continued use of the service after changes constitutes acceptance of the updated Terms.
        </p>

        <h2 className="text-xl font-semibold text-blue-500 mt-6 mb-2">8. Contact</h2>
        <p className="text-gray-700">
          For any questions about these Terms, please <a href="/contact" className="text-blue-600 underline">contact us</a>.
        </p>
      </div>
    </div>
  );
};

export default Terms;
